import React, { useState } from 'react';
import Popup from '../../../../../../components/popup';
import Button from '../../../../../../components/button';
import Icon from '../../../../../../components/icon';
import {toLocalDateTimeWithoutSeconds} from '../../../../../../utils';
import './index.css';

export default function RestoreModal({ isOpen, historyItem, labels, onClose, onConfirm, isLoading, error }) {
	const [targetGroupId, setTargetGroupId] = useState('');

	if (!isOpen || !historyItem) return null;

	const entry = historyItem.snapshot || historyItem.previousSnapshot || historyItem.currentContactEntry || {};
	const contactName = [entry.givenName, entry.familyName].filter(Boolean).join(' ') || entry.email || 'this contact';
	const authorName = historyItem.actionBy?.name || historyItem.actionBy?.email || 'a team member';

	const availableLabels = labels || [];

	return (
		<Popup onClose={onClose} className="restore-modal-popup">
			<div className="restore-modal-body p-4">
				<div className="text-center mb-3">
					<div className="restore-modal-icon-wrapper">
						<Icon name="recycle" className="text-success fa-2x" />
					</div>
					<h3 className="mt-2 mb-1">Restore Contact</h3>
					<p className="text-muted">
						Restore <strong>{contactName}</strong> back to your contacts directory.
					</p>
				</div>

				<div className="restore-details-card bg-light p-3 rounded mb-3">
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">Status:</span>
						<span className="badge badge-danger">Deleted</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">Deleted by:</span>
						<span>{authorName}</span>
					</div>
					<div className="d-flex justify-content-between">
						<span className="text-muted">Deleted on:</span>
						<span>{toLocalDateTimeWithoutSeconds(historyItem.createdAt)}</span>
					</div>
				</div>

				<div className="form-group mb-4">
					<label htmlFor="restoreTargetLabel" className="font-weight-bold text-dark">
						Destination Label:
					</label>
					<select
						id="restoreTargetLabel"
						className="form-control"
						value={targetGroupId}
						onChange={(e) => setTargetGroupId(e.target.value)}
						disabled={isLoading}
					>
						<option value="">Restore to original label(s)</option>
						{availableLabels.map((lbl) => (
							<option key={lbl.id} value={lbl.id}>
								{lbl.name}
							</option>
						))}
					</select>
					<small className="form-text text-muted">
						Select a specific shared label or restore to original labels.
					</small>
				</div>

				<div className="alert alert-light border py-2 mb-3">
					<small className="text-muted d-block">
						<Icon name="info-circle" className="text-info mr-1" />
						Restoring reinstates this contact from its deletion snapshot without creating duplicate entries.
					</small>
				</div>

				{error && (
					<div className="alert alert-danger py-2 mb-3">
						<small>{error.message || 'Failed to restore contact. Please try again.'}</small>
					</div>
				)}

				<div className="d-flex justify-content-end gap-2">
					<Button className="btn-secondary mr-2" onClick={onClose} disabled={isLoading}>
						Cancel
					</Button>
					<Button
						className="btn-success"
						onClick={() => onConfirm(historyItem.id, targetGroupId || null)}
						disabled={isLoading}
					>
						{isLoading ? (
							<span><Icon name="circle-o-notch" animated="spin" className="mr-1" /> Restoring...</span>
						) : (
							<span><Icon name="check" className="mr-1" /> Restore Contact</span>
						)}
					</Button>
				</div>
			</div>
		</Popup>
	);
}
